import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import * as ALL_DOCUMENTS from '../../constants/helloSignDocumentInfo';
import * as firebaseDocumentCalls from '../../api/Clients/getFirebaseDocumentInfo.api';
import * as DOCUMENT_NAME from '../../constants/documentNames';
import setLotToAvailable from '../Agreement/setLotToAvailable.api';

const firebaseRef = firebase.database();

export async function cancelForm(
	lotId,
	leadId,
	authToken,
	documentName,
	setAlert
) {
	var jsonData = { leadId: leadId };
	jsonData['thisUserId'] = firebase.auth().currentUser.uid;
	jsonData['projectCode'] = PROJECT_CODE.projectCode;
	jsonData['authToken'] = authToken;
	jsonData['subjectName'] = documentName;

	var getClientDocumentInfo;

	if (
		documentName === DOCUMENT_NAME.aps ||
		documentName === DOCUMENT_NAME.aps
	) {
		console.log('cancelForm I am a main form');
		getClientDocumentInfo = firebase
			.functions()
			.httpsCallable('HelloSignCancelSignatureRequest');
	} else {
		console.log('cancelForm I am an extrra form');
		getClientDocumentInfo = firebase
			.functions()
			.httpsCallable('HelloSignCancelSignatureRequestExtras');
	}

	var finalResult;

	console.log('cancelAPSForm jsonData', jsonData);

	await getClientDocumentInfo(jsonData).then((result) => {
		finalResult = result;
	});

	if (finalResult.data.success === false) {
		setAlert({
			alertType: 'warning',
			message:
				'This document could not be cancelled at this time. Try deleting the purchaser instead.',
		});
	} else {
		setAlert({
			alertType: 'success',
			message:
				'This document has successfully been cancelled. Please wait a few seconds for this to take effect.',
		});
		if (documentName === DOCUMENT_NAME.aps) {
			if (lotId) {
				setLotToAvailable(lotId);
			}
		}
	}

	return finalResult;
}
